<template>
  <div class="wrap container-fluid vertical-spacing">
    <div class="row">
      <div class="col-xs-12">
        <OrderDetails />
      </div>
    </div>
  </div>
</template>

<script>
import OrderDetails from '../components/account/OrderDetails.vue';

export default {
  name: 'OrderDetailsPage',
  components: {
    OrderDetails,
  },
};
</script>

<style lang="scss" scoped></style>
